<template>
    <div class="chartContainer text-center">
        <h2 class="h3">Pressure</h2>
        <Doughnut :options="chartOptions" :data="chartData()" />
        <h3 class="h4">{{ value }} mb</h3>
    </div>
</template>
  
<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
    name: 'PressureChart',
    props: ['value'],
    components: { Doughnut },
    computed: {
        dataSetData() {
            let valueArc = this.value - 960;
            let remainderArc = this.range - valueArc;
            return [(valueArc/this.range),(remainderArc/this.range)]
        },
        arcColor() {
            if (this.value < 985) {
                return '#0dcaf0'; // Light Blue for very low pressure
            } else if (this.value >= 985 && this.value < 1006) {
                return '#198754'; // Green for low pressure
            } else if (this.value >= 1006 && this.value < 1016) {
                return '#ffc107'; // Light Yellow for moderate pressure
            } else if (this.value >= 1016 && this.value < 1026) {
                return '#fd7e14'; // Yellow for high pressure
            } else if (this.value >= 1026) {
                return '#dc3545'; // Orange for very high pressure
            }
            return '#198754'; // Default color, if needed
        }
    },
    methods: {
        chartData() {
            return {
                labels: ['Pressure (mb)'],
                datasets: [{
                    data: this.dataSetData,
                    label: 'Pressure (mb)',
                    backgroundColor: [this.arcColor, "#2b3035"]
                }]
            }
        }
    },
    data() {
        return {
            range: 90,
            chartOptions: {
                rotation: 270,
                cutout: '60%',
                circumference: 180,
                responsive: true,
                aspectRatio:2,
                layout: {
                    autoPadding: false,
                    padding:0
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },

            },
        }
    }
}
</script>